import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import Note from "@/components/molecules/Note";
interface NotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialContent: string;
  onSave: (content: string) => void;
}
export function NotesModal({
  isOpen,
  onClose,
  initialContent = "",
  onSave
}: NotesModalProps) {
  return <Dialog.Root open={isOpen} onOpenChange={onClose} data-sentry-element="unknown" data-sentry-component="NotesModal" data-sentry-source-file="index.tsx">
            <Dialog.Portal data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm" data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
                <Dialog.Content className="fixed left-[50%] top-[50%] z-50 max-h-[85vh] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-slate-900 p-6 shadow-lg" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <div className="flex items-center justify-between mb-4">
                        <Dialog.Title className="text-xl font-semibold text-white-500" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            Notes
                        </Dialog.Title>
                        <Dialog.Close className="rounded-full p-1.5 hover:bg-gray-100" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                            <X className="h-5 w-5 text-gray-500" data-sentry-element="X" data-sentry-source-file="index.tsx" />
                        </Dialog.Close>
                    </div>

                    <div className="min-h-[300px] max-h-[50vh] overflow-y-auto rounded-lg">
                        <Note initialContent={initialContent} onSave={onSave} onClose={onClose} data-sentry-element="Note" data-sentry-source-file="index.tsx" />
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>;
}